<template>
  <div>this is Agent Deals</div>
</template>
<script>
export default {
  name: 'AgentDeals'
}
</script>
